






















import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import AppButton from '@/components/common/AppButton.vue'
import {Task, Signature, Location} from '@/store/types'
import SurveyModel from '@/classes/SurveyModel'
import {Getter, Mutation, Action} from 'vuex-class'
import DateFormatter from '@/classes/DateFormatter'
import moment from 'moment'
import TimeService from '@/classes/TimeService'

@Component({
  components: {
    AppButton,
  },
})

export default class TaskStatusButton extends Vue {
  @Getter('task') public task!: Task
  @Getter('location') public location!: Location
  @Getter('surveyInProgress') public surveyInProgress!: boolean
  @Getter('signature') public signature!: Signature
  @Mutation('setTask') public setTask!: any
  @Mutation('setCompletedTask') public setCompletedTask!: any
  @Mutation('setStartSurveyConfirmationModal') public setStartSurveyConfirmationModal!: any
  @Mutation('setCompleteSurveyConfirmationModal') public setCompleteSurveyConfirmationModal!: any
  @Mutation('setLoader') public setLoader!: any
  @Mutation('setFlashMessage') public setFlashMessage!: any
  @Action('updateTask') public updateTask!: any

  public SurveyModel = SurveyModel
  public time: number = 0
  public load: boolean = false
  public timeInterval: any = null
  public doubleConfirmationModal = false

  public get buttonClass() {
    if (this.disabled) {
      return ''
    }

    if (this.task.status === SurveyModel.STATUS.PENDING) {
      return 'button-secondary'
    } else if (this.task.status === SurveyModel.STATUS.ACTIVE) {
      return 'button-primary'
    } else if (this.task.status === SurveyModel.STATUS.IN_PROGRESS) {
      return 'button-success'
    } else {
      return ''
    }
  }
  public get buttonText() {
    if (this.task.status === SurveyModel.STATUS.PENDING) {
      return 'Confirm Survey'
    } else if (this.task.status === SurveyModel.STATUS.ACTIVE) {
      return 'Start Survey'
    } else {
      return 'Complete Survey'
    }
  }

  public get today() {
    const dateFormatter = new DateFormatter()
    return dateFormatter.setFormat('MM-DD-YYYY').get('')
  }
  public get date() {
    const dateFormatter = new DateFormatter()
    return dateFormatter.setFormat('MM-DD-YYYY').get(this.task.date)
  }
  public get disabled() {
    return (this.task.status === SurveyModel.STATUS.PENDING &&
      (!this.task.date || !this.task.date.length || !this.task.time || !this.task.time.length)) ||
      (this.task.status === SurveyModel.STATUS.ACTIVE && this.surveyInProgress) ||
      (this.task.status === SurveyModel.STATUS.ACTIVE && this.today !== this.date) ||
      (this.task.status === SurveyModel.STATUS.IN_PROGRESS && !this.signature) || this.load
  }
  public get timeDuration() {
    const time = moment.duration(this.time, 'seconds')
    return (time.hours() <= 9 ? '0' + time.hours() : time.hours())
      + ':' + (time.minutes() <= 9 ? '0' + time.minutes() : time.minutes())
      + ':' + (time.seconds() <= 9 ? '0' + time.seconds() : time.seconds())
  }
  public get getData() {
    const dateFormatter = new DateFormatter()

    if (this.task.status === SurveyModel.STATUS.PENDING) {
      return {
        status: SurveyModel.STATUS.ACTIVE,
        accepted_at: dateFormatter.setServerTimezone().get(),
      }
    } else if (this.task.status === SurveyModel.STATUS.ACTIVE) {
      return {
        status: SurveyModel.STATUS.IN_PROGRESS,
        started_at: dateFormatter.setServerTimezone().get(),
      }
    } else if (this.task.status === SurveyModel.STATUS.IN_PROGRESS) {
      return {
        status: SurveyModel.STATUS.COMPLETED,
        completed_at: dateFormatter.setServerTimezone().get(),
        signature: this.signature.image,
      }
    }
  }

  public updateStatus() {
    if (this.disabled) {
      return
    }
    if (this.task.status === SurveyModel.STATUS.ACTIVE) {
      this.setStartSurveyConfirmationModal(true)
      return
    }
    if (this.task.status === SurveyModel.STATUS.IN_PROGRESS) {
      clearInterval(this.timeInterval)
      this.setCompleteSurveyConfirmationModal(true)
      return
    }
    this.load = true
    this.updateTask(Object.assign({lead_location_id: this.location.id}, this.task, this.getData))
      .then((task: Task) => {
        this.load = false
      }).catch((error: any) => {
      const payload = {
        flash: true,
        message: error.response.data.message,
        type: 2,
      }
      this.setLoader(false)
      this.setFlashMessage(payload)
    })
  }

  public clockTick() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval)
    }
    this.time = TimeService.diff(this.task.started_at, this.task.completed_at)
    if ( this.task.status === SurveyModel.STATUS.IN_PROGRESS ) {
      if (this.timeInterval) {
        clearInterval(this.timeInterval)
      }
      this.timeInterval = setInterval(() => {
        this.time++
      }, 1000)
    }
  }

  @Watch('task.status')
  public onStatusChanged(status: number) {
    this.clockTick()
  }

  public mounted() {
    this.clockTick()
  }
 }
